
const faqFunction = () => {
    const tabs = document.querySelectorAll('.js-faq-tab');
    const questions = document.querySelectorAll('.js-faq-question');
    const answers = document.querySelectorAll(".js-faq-answer");
    const contents = document.querySelectorAll(".js-faq-content");
    const faqWrap = document.querySelectorAll(".js-faq-item-wrap");
    const headerSticky = document.querySelector(".header-sticky");
    const IS_ACTIVE = 'is-active';
    let newHeight = 0;

    if(tabs) {
        faqWrap[0].querySelector('.js-faq-tab').classList.add(IS_ACTIVE);
        const faqWrapHeight = faqWrap[0].querySelector('.js-faq-tab').nextElementSibling.querySelector('.js-faq-content-inner').clientHeight;
        const faqWrapInnerHeight = faqWrap[0].querySelector('.js-faq-tab').nextElementSibling.querySelectorAll('.js-faq-answer-inner');
        faqWrapInnerHeight.forEach(item => {
            newHeight += item.clientHeight;
        })
        faqWrap[0].querySelector('.js-faq-tab').nextElementSibling.style.maxHeight = `${faqWrapHeight + newHeight}px`;
        faqWrap[0].querySelectorAll('.js-faq-question').forEach(item => {
            item.classList.add(IS_ACTIVE);
            item.nextElementSibling.style.maxHeight = `${newHeight}px`;
        });
        tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                let newHeight2 = 0;
                const height = e.target.offsetParent.nextElementSibling.querySelector('.js-faq-content-inner').getBoundingClientRect().height;
                const heightInnerItems = e.target.offsetParent.nextElementSibling.querySelector('.js-faq-content-inner').querySelectorAll('.js-faq-answer-inner');
                heightInnerItems.forEach(item => {
                    newHeight2 += item.clientHeight;
                })
                let headerHeight = headerSticky.getBoundingClientRect().height + 20;
                if(headerSticky) {
                    if (window.width <= 768) {
                        headerHeight = headerSticky.getBoundingClientRect().height - 20;
                    } else {
                        headerHeight = headerSticky.getBoundingClientRect().height;
                    }
                }

                if (e.target.offsetParent.classList.contains(IS_ACTIVE)) {
                    e.target.offsetParent.classList.remove(IS_ACTIVE);
                    e.target.offsetParent.nextElementSibling.style.maxHeight = 0;
                } else {
                    tabs.forEach((item) => {
                        item.classList.remove(IS_ACTIVE);
                    });
                    contents.forEach((item) => {
                        item.style.maxHeight = 0;
                    });
                    questions.forEach((item) => {
                        item.classList.remove(IS_ACTIVE);
                    });
                    answers.forEach((item) => {
                        item.style.maxHeight = 0;
                    });
                    e.target.offsetParent.classList.add(IS_ACTIVE);
                    e.target.offsetParent.nextElementSibling.style.maxHeight = `${
                        height + newHeight2
                    }px`;

                    setTimeout(() => {
                        let scrollTop = e.target.getBoundingClientRect().top;
                        let bodyRect = document.body.getBoundingClientRect().top;
                        let offset = (scrollTop - bodyRect);
                        window.scroll({
                            top: (offset - headerHeight),
                            left: 0,
                            behavior: 'smooth'
                        });
                    }, 400);
                }
            })
        })

        if(questions) {
            questions.forEach(question => {
                question.addEventListener('click', (e) => {
                    e.preventDefault();
                    const heightInner = e.target.offsetParent.nextElementSibling.querySelector('.js-faq-answer-inner').getBoundingClientRect().height;
                   
                    if (e.target.offsetParent.classList.contains(IS_ACTIVE)) {
                        e.target.offsetParent.classList.remove(IS_ACTIVE);
                        e.target.offsetParent.nextElementSibling.style.maxHeight = 0;
                    } else {
                        e.target.offsetParent.parentElement.parentElement.querySelectorAll(".js-faq-question")
                        .forEach((item) => {
                            item.classList.remove(IS_ACTIVE);
                        });
                        e.target.offsetParent.parentElement.parentElement.querySelectorAll(".js-faq-answer")
                        .forEach((item) => {
                            item.style.maxHeight = 0;
                        });
                        e.target.offsetParent.classList.add(IS_ACTIVE);
                        e.target.offsetParent.nextElementSibling.style.maxHeight = `${
                            heightInner
                        }px`;
                    }
                })
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    faqFunction();
});

document.addEventListener('shopify:section:load', () => {
    faqFunction();
});